// @ts-nocheck
/* eslint-disable */
'use strict';

export class PickLists {
    // Map<fieldNameKey, string[Display Value][AltText]>
    private static PickList: Map<string, string[][]> = new Map();

    public static InitPickLists() {
        PickLists.PickList.set('EX_BSMEXIT', [
            ['Walk-out', 'wo'],
            ['Walk-up', 'wu'],
            ['Interior-only', 'in']
        ]);
        PickLists.PickList.set('DP_SITVW1', [
            ['Neutral', 'N'],
            ['Beneficial', 'B'],
            ['Adverse', 'A']
        ]);
        PickLists.PickList.set('DP_SITVW2', [
            ['Water', 'Wtr'],
            ['Pastoral', 'Pstrl'],
            ['Woods', 'Woods'],
            ['Park', 'Prk'],
            ['Golf Course', 'Glfvw'],
            ['City/Skyline', 'CtySky'],
            ['Mountain', 'Mtn'],
            ['Residential', 'Res'],
            ['City Street', 'CtyStr'],
            ['Industrial', 'Ind'],
            ['Power Lines', 'PwrLn'],
            ['Limited Sight', 'LtdSght'],
            ['Other (describe)', 'OTH']
        ]);
        PickLists.PickList.set('DP_SITVW3', [
            ['Water', 'Wtr'],
            ['Pastoral', 'Pstrl'],
            ['Woods', 'Woods'],
            ['Park', 'Prk'],
            ['Golf Course', 'Glfvw'],
            ['City/Skyline', 'CtySky'],
            ['Mountain', 'Mtn'],
            ['Residential', 'Res'],
            ['City Street', 'CtyStr'],
            ['Industrial', 'Ind'],
            ['Power Lines', 'PwrLn'],
            ['Limited Sight', 'LtdSght'],
            ['Other (describe)', 'OTH']
        ]);
        PickLists.PickList.set('DP_FINTYP1', [
            ['FHA', 'FHA'],
            ['VA', 'VA'],
            ['Conventional', 'Conv'],
            ['Seller', 'Seller'],
            ['Cash', 'Cash'],
            ['USDA - Rural Housing', 'RH'],
            ['Other (describe)', 'OTH']
        ]);
        PickLists.PickList.set('DP_LOCAT', [
            ['Neutral', 'N'],
            ['Beneficial', 'B'],
            ['Adverse', 'A']
        ]);
        PickLists.PickList.set('DP_LOC1', [
            ['Residential', 'Res'],
            ['Industrial', 'Ind'],
            ['Commercial', 'Comm'],
            ['Busy Road', 'BsyRd'],
            ['Water Front', 'WtrFr'],
            ['Golf Course', 'GlfCse'],
            ['Adj. to Park', 'AdjPrk'],
            ['Adj. to Pwr Lines', 'AdjPwr'],
            ['Landfill', 'Lndfl'],
            ['Public Transit', 'PubTrn'],
            ['Other (describe)', 'OTH']
        ]);
        PickLists.PickList.set('DP_LOC2', [
            ['Residential', 'Res'],
            ['Industrial', 'Ind'],
            ['Commercial', 'Comm'],
            ['Busy Road', 'BsyRd'],
            ['Water Front', 'WtrFr'],
            ['Golf Course', 'GlfCse'],
            ['Adj. to Park', 'AdjPrk'],
            ['Adj. to Pwr Lines', 'AdjPwr'],
            ['Landfill', 'Lndfl'],
            ['Public Transit', 'PubTrn'],
            ['Other (describe)', 'OTH']
        ]);
        PickLists.PickList.set('DP_CMPTYPE', [
            ['Active', 'Active'],
            ['Contract', 'c'],
            ['Expired', 'e'],
            ['Withdrawn', 'w'],
            ['Settled sale', 's']
        ]);
    }

    /*
     * Serch PickList with given key for matching display value (DP_XXX field on TOTAL forms).
     * returns true if value found, otherwise false.
     */
    public static ContainsValue(key: string, value: string): boolean {
        if (value?.length == 0) return false;
        var result: boolean = false;
        var tmpVal = value.toLowerCase();
        var pickList: string[][] = this.PickList.get(key);
        for (var i: number = 0; i < pickList.length; i++) {
            var val: string = pickList[i][0].toLowerCase();
            if (val.toLowerCase().startsWith(tmpVal)) {
                result = true;
                break;
            }
        }
        return result;
    }

    /*
     * Search PickList with given key for matching display value and return AltText (DH_XXX field on TOTAL forms).
     */
    public static GetAltText(key: string, value: string): string {
        if (value?.length == 0) return '';
        var result: string = '';
        var tmpVal = value.toLowerCase();
        var pickList: string[][] = this.PickList.get(key);
        for (var i: number = 0; i < pickList.length; i++) {
            var val: string = pickList[i][0].toLowerCase();
            if (val.toLowerCase().startsWith(tmpVal)) {
                result = pickList[i][1];
                break;
            }
        }
        return result;
    }
}
